module.exports = __webpack_public_path__ + "static/italia-oggi-logo-5a6b6de1668cc7eb55e9553d346c4922.png";